module.exports = __webpack_public_path__ + "assets/img/c5076d208462611988dca84d9696656e.svg";